interface Service<P, R> {
  [key: string]: (params: P) => R;
}

class CardTemplateService {
  services: { [key: string]: any };
  constructor() {
    this.services = {};
  }
  addService<P, R>(key: string, value: Service<P, R>) {
    this.services[key] = { ...this.services[key], ...value };
  }
  removeSevice(nameSpace: string, fnName?: string) {
    if (fnName) {
      delete this.services[nameSpace]?.[fnName];
    } else {
      delete this.services[nameSpace];
    }
  }
}

export default new CardTemplateService();
